"use client";

import { content } from "../data/siteData";

const Navbar = ({ activeSection, locale }) => {
  const { nav, languageSwitch } = content[locale];

  return (
    <nav className="w-full py-6 px-6 md:py-8 md:px-12 flex justify-center items-center gap-6 md:gap-12">
      {nav.map((item) => {
        const isActive = activeSection === item.id;
        return (
          <a
            key={item.id}
            href={`#${item.id}`}
            className={`nav-item font-poppins text-sm md:text-lg font-extralight transition-colors relative group ${
              isActive ? "text-[#333333]" : "text-gray-500 hover:text-gray-800"
            }`}
            aria-current={isActive ? "page" : undefined}
          >
            {item.label}
            <span
              className={`absolute -bottom-1 left-0 h-[2px] bg-[#333333] transition-all duration-300 ${
                isActive ? "w-full" : "w-0 group-hover:w-full"
              }`}
            ></span>
          </a>
        );
      })}
      <a
        href={languageSwitch.href}
        hrefLang={languageSwitch.hrefLang}
        lang={languageSwitch.hrefLang}
        aria-label={languageSwitch.ariaLabel}
        className="font-poppins text-xs md:text-sm font-light text-[#333333] border border-[#333333] rounded-full px-2.5 py-0.5 hover:bg-[#333333] hover:text-white transition-colors"
      >
        {languageSwitch.label}
      </a>
    </nav>
  );
};

export default Navbar;
